import React, { useMemo } from 'react';
import { CHART_RANGE_PRESETS, CHART_TRANSFORMS } from './chartSpec';

const RANGE_LABELS = {
  '1y': '1A',
  '5y': '5A',
  '10y': '10A',
  all: 'Todo',
};

const TRANSFORM_LABELS = {
  none: 'Nivel',
  index100: 'Índice 100',
  yoy: 'YoY',
  mom: 'MoM',
};

/**
 * Analysis-density toolbar: range presets, transforms, export hooks, fullscreen.
 */
export function ChartToolbar({
  range = 'all',
  transform = 'none',
  onRangeChange,
  onTransformChange,
  onExport,
  onToggleFullscreen,
  fullscreen = false,
}) {
  return (
    <div className="oikra-chart__toolbar" role="toolbar" aria-label="Controles del gráfico">
      <div className="oikra-chart__toolbar-group" role="group" aria-label="Rango temporal">
        {CHART_RANGE_PRESETS.map((preset) => (
          <button
            key={preset}
            type="button"
            className={`oikra-chart__tool-btn${range === preset ? ' is-active' : ''}`}
            aria-pressed={range === preset}
            onClick={() => onRangeChange?.(preset)}
          >
            {RANGE_LABELS[preset]}
          </button>
        ))}
      </div>
      <div className="oikra-chart__toolbar-group" role="group" aria-label="Transformación">
        {CHART_TRANSFORMS.map((value) => (
          <button
            key={value}
            type="button"
            className={`oikra-chart__tool-btn${transform === value ? ' is-active' : ''}`}
            aria-pressed={transform === value}
            onClick={() => onTransformChange?.(value)}
          >
            {TRANSFORM_LABELS[value]}
          </button>
        ))}
      </div>
      <div className="oikra-chart__toolbar-group" role="group" aria-label="Exportar">
        {['png', 'svg'].map((format) => (
          <button
            key={format}
            type="button"
            className="oikra-chart__tool-btn"
            onClick={() => onExport?.(format)}
          >
            {format.toUpperCase()}
          </button>
        ))}
      </div>
      <button
        type="button"
        className={`oikra-chart__tool-btn${fullscreen ? ' is-active' : ''}`}
        aria-pressed={fullscreen}
        onClick={() => onToggleFullscreen?.()}
      >
        {fullscreen ? 'Salir' : 'Pantalla completa'}
      </button>
    </div>
  );
}

export function ChartLegend({ series, colorsById, onToggle }) {
  const items = useMemo(() => (Array.isArray(series) ? series : []), [series]);
  if (!items.length) return null;

  return (
    <div className="oikra-chart__legend" role="list" aria-label="Series">
      {items.map((item) => {
        const color = colorsById?.[item.id] || 'var(--data-color-1)';
        return (
          <button
            key={item.id}
            type="button"
            className={`oikra-chart__legend-item${item.hidden ? ' is-hidden' : ''}`}
            aria-pressed={!item.hidden}
            aria-label={item.label}
            title={item.hidden ? 'Mostrar serie' : 'Ocultar serie'}
            onClick={() => onToggle?.(item.id)}
          >
            <span className="oikra-chart__legend-swatch" style={{ color }} aria-hidden />
            <span aria-hidden>{item.label}</span>
          </button>
        );
      })}
    </div>
  );
}
